import { render, staticRenderFns } from "./AXlogin.vue?vue&type=template&id=99351736&scoped=true&"
import script from "./AXlogin.vue?vue&type=script&lang=js&"
export * from "./AXlogin.vue?vue&type=script&lang=js&"
import style0 from "./AXlogin.vue?vue&type=style&index=0&id=99351736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99351736",
  null
  
)

export default component.exports